import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function FindHomeView() {
  useDocumentTitle('Finding A home-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb
        image={'bg-image-14'}
        title={'Finding A Home'}
        link={'finding-a-home'}
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105 ">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">
                FINDING YOU A PROPERTY THROUGH CHOICE-BASED LETTINGS
              </h2>
              <h3 className="text-left compassion">
                What are Choice-Based Lettings?
              </h3>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">C</span>hoice Based
                  Lettings is a new way to rent a home from the council and some
                  housing associations. The old way of renting a home meant that
                  you applied for a home and you stayed on a waiting list until
                  you were offered one. Choice Based Lettings are different.
                  Homes are advertised on the Internet and in a newspaper by
                  estate agents. You choose the homes you are interested in –
                  this is called bidding. Different councils run schemes a
                  little bit differently from each other
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/excellence">
                        Quality and Clinical Excellence
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/how-we-deliver">
                        How we deliver our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-values">
                        Our Values
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/funding">
                        Funding your care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  How do Choice-Based Lettings work?
                </h2>
                <p className="white-color">
                  You will need to apply. You will need to say what type of home
                  you are looking for and the area you want to live in. You will
                  also need to say why you need to move out of the home you
                  currently occupy. Your doctor, social worker or someone who
                  knows you well may need to give more information.
                </p>
                <p className="white-color">Find out which band you are in</p>
                <p className="white-color">
                  Band A = people needing a new home the most, like homeless
                  people
                </p>
                <p className="white-color">
                  Band B = people needing a new home quickly
                </p>
                <p className="white-color">
                  Band C = people who need a new home but can wait
                </p>
                <p className="white-color">
                  Band D = people who need a home the least
                </p>
                <p className="white-color">
                  Some homes advertised are only for people who need a home
                  quickly.
                </p>
                <p className="white-color">
                  Some homes advertised are only for people who are over 55
                  years old.
                </p>
                <p className="white-color">
                  Some homes advertised are only for people with a disability.
                </p>
                <p className="white-color">
                  You will be told which homes you can choose from. You will be
                  told which homes you can choose from.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Choosing a home</h2>
                <p className="">
                  You can choose a number of homes. You can choose the homes you
                  like every 1 or 2 weeks. Homes are advertised in a newspaper
                  and on the Internet.
                </p>
                <p></p>
                <p>
                  You can say you are interested in a home in different ways
                </p>
                <div>
                  <ul className="care_bullets2">
                    <li>By telephone</li>
                    <li>By text</li>
                    <li>By digiTv</li>
                    <li>By post</li>
                    <li>At the Property shop or housing office</li>
                    <li>
                      A person you choose or a person from the housing office
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Getting a home</h2>
                <p className="white-color">
                  You may be asked to go and see a home you have chosen. You
                  will be asked to look at the home and see if you want it
                </p>
                <p className="white-color">
                  It can sometimes take a long time to be asked to see a home.
                  It is important that you keep choosing homes that you like
                  every week. You will be told about the reasons someone else
                  was given the home you wanted like which band they were in and
                  how long they have waited.
                </p>
                <h2 className="white-color">
                  Agree to the rules and get your keys
                </h2>
                <p className="white-color">
                  You will be asked to decide whether you want the home you have
                  looked at. You will be asked to agree on the rules about
                  having your home – this is called a tenancy agreement. When
                  you agree on the rules you will get your keys to your new
                  home.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Getting help</h2>
                <p className="">
                  The Disability Equality Duty says that people with a
                  disability should get extra help from the council to get
                  housing if they need it. You can get help to make the
                  application. You can get help if you are homeless and need a
                  home quickly. You can get help to say which homes you like you
                  can get housing staff to choose for you. You can get extra
                  time to decide on your home if you need to because of your
                  disability. You can get help with moving and getting
                  furniture. You can get help to look at other ways to get
                  housing, it is important to ask about this when you first
                  apply for a home. You might also need help from your carer or
                  family member.
                </p>
                <p>
                  *For your own peace of mind, Quality Health and Homecare
                  Services Ltd is able to provide you with support at every
                  stage of your application*
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left"></div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default FindHomeView;
